import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-back-header',
  templateUrl: './back-header.component.html',
  styleUrls: ['./back-header.component.scss'],
})
export class BackHeaderComponent {
  @Input() title = '';
  @Output() goBackEmit = new EventEmitter<void>();
  constructor() {}

  goBack() {
    this.goBackEmit.emit();
  }
}
